import { z } from 'zod';
import { avatarConfigSchema } from './avatar.js';
import { avatarKindSchema } from './photos.js';
import { readAloudSchema } from './read-aloud.js';
/**
 * Every API boundary in this app validates with one of these schemas. They live
 * in @qq/shared so the browser and the server can never drift apart on shape.
 */
export const parentLoginInput = z.object({
    email: z.string().trim().toLowerCase().email().max(254),
    password: z.string().min(10).max(200),
});
/** Four digits. Deliberately not a password: it guards a child's own shelf, and
 *  the throttle - not the entropy - is what makes it safe enough. */
export const childPin = z.string().regex(/^\d{4}$/, 'PIN must be exactly four digits');
export const childLoginInput = z.object({
    childId: z.string().uuid(),
    pin: childPin,
});
export const setChildPinInput = z.object({
    childId: z.string().uuid(),
    pin: childPin,
});
/** What the child profile-picker screen is allowed to know before login.
 *  Nickname + avatar only: no DOB, no year level, no progress. */
export const childPickerEntry = z.object({
    id: z.string().uuid(),
    nickname: z.string(),
    avatarConfig: avatarConfigSchema,
    companionId: z.string().nullable(),
});
export const parentSessionUser = z.object({
    kind: z.literal('parent'),
    id: z.string().uuid(),
    familyId: z.string().uuid(),
    name: z.string(),
    email: z.string(),
});
export const childSessionUser = z.object({
    kind: z.literal('child'),
    id: z.string().uuid(),
    familyId: z.string().uuid(),
    nickname: z.string(),
    yearLevelLabel: z.string(),
    companionId: z.string().nullable(),
    avatarConfig: avatarConfigSchema,
    avatarKind: avatarKindSchema,
    hasPhoto: z.boolean(),
    /** Changes whenever the photo does, so the image URL busts its own cache. */
    photoUpdatedAt: z.string().nullable(),
    /** Resolved on the server; the screen never works it out from the year. */
    readAloud: readAloudSchema,
    /** The collectible that comes along, if they chose one and still own it. */
    buddy: z.object({ key: z.string(), name: z.string() }).nullable(),
    cardsOwned: z.number().int().min(0),
});
export const sessionUser = z.discriminatedUnion('kind', [parentSessionUser, childSessionUser]);
//# sourceMappingURL=auth.js.map